import React from "react";
import { Wallet, ShieldCheck, HeartHandshake, Search, Clock4, Award } from "lucide-react";

const BENEFITS = [
  {
    Icon: Search,
    title: "30+ Carriers Shopped For You",
    desc: "We compare top-rated insurers like Mutual of Omaha, AIG, and Globe Life in one call — so you don't waste hours on paperwork.",
  },
  {
    Icon: Wallet,
    title: "Built for Fixed Incomes",
    desc: "Plans designed around Social Security budgets. Many options start under $20/month with rates locked for life.",
  },
  {
    Icon: ShieldCheck,
    title: "No Medical Exam Needed",
    desc: "Most of our plans require no doctor visit, no blood work, and no lengthy questionnaire — just a few yes/no questions.",
  },
  {
    Icon: HeartHandshake,
    title: "Protect Your Loved Ones",
    desc: "Cover final expenses, funeral costs, and small debts so your family isn't left with the bill during a difficult time.",
  },
  {
    Icon: Clock4,
    title: "Coverage Starts Quickly",
    desc: "Many seniors qualify immediately on the call. Same-day issue available on select guaranteed-issue plans.",
  },
  {
    Icon: Award,
    title: "Licensed, Friendly Agents",
    desc: "Real American agents. No call centers, no pressure — just clear answers about what fits your budget.",
  },
];

export const Benefits = () => {
  return (
    <section
      id="benefits"
      data-testid="benefits-section"
      className="py-16 md:py-24 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="max-w-3xl">
          <p className="text-xs md:text-sm uppercase tracking-[0.22em] font-semibold text-green-700">
            Why Seniors Choose Us
          </p>
          <h2
            data-testid="benefits-heading"
            className="font-serif-display mt-3 text-3xl md:text-5xl font-bold leading-tight tracking-tight text-blue-900"
          >
            One phone call. The lowest rate from 30+ carriers.
          </h2>
          <p className="mt-5 text-xl text-slate-700 leading-relaxed">
            You shouldn&apos;t have to choose between groceries and peace of mind.
            We do the shopping — you choose what&apos;s affordable.
          </p>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {BENEFITS.map(({ Icon, title, desc }, idx) => (
            <article
              key={title}
              data-testid={`benefit-card-${idx}`}
              className="group bg-white rounded-2xl p-8 border border-slate-100 shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200"
            >
              <div className="h-14 w-14 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center">
                <Icon className="h-7 w-7 text-blue-900" />
              </div>
              <h3 className="mt-5 text-2xl font-bold text-slate-900 leading-snug">
                {title}
              </h3>
              <p className="mt-3 text-lg text-slate-700 leading-relaxed">
                {desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
